import {FacebookSettings} from "./FacebookSettings";
import {SimpleCommand} from "./../../../commanding/SimpleCommand";
import {commentedOut} from "../../../../../decorators";
import {ExternalInterface} from "@goodgamestudios/createjs-utilities";

export class BasicInitializeFacebookConnectCommand extends SimpleCommand {


    /**
     *
     * Loads a given JavaScript file while setting script elements to html
     * Attention: Check with isJsAvailable() before you call this methode
     *
     * */
    @commentedOut("", "Facebook Connect - ExternalInterface - Page Integration stuff")
    public loadJS(jsFilePath: string): void {
        // TODO: @HTML5 check how to load a script on HTML document
        /*
         ExternalInterface.call("document.getElementsByTagName('head')[0].appendChild(document.createElement('script'))");
         ExternalInterface.call("document.getElementsByTagName('script')[document.getElementsByTagName('head')[0].getElementsByTagName('script').length-1].setAttribute('type', 'text/javascript')");
         ExternalInterface.call("document.getElementsByTagName('script')[document.getElementsByTagName('head')[0].getElementsByTagName('script').length-1].setAttribute('src', '" + jsFilePath + "')");
         */
    }


    /**
     *
     * Checks if a given functionName is in javaScript defined as a function
     * Attention: Check with isJsAvailable() before you call this methode
     *
     * */
    public  checkIfJsFunctionExists(functionName: string): boolean {
        // TODO: @HTML5 how to check if a function is valid on JavaScript context?
        // function will reside on the integration page.  to know if it exists we need to rely on  the messagehandler.  that will require an async call that returns an error.
        // but if there is, the function will be executed.  that is something we dont want here  find better implementation

        // return ExternalInterface.call("Function(\"" + "return (typeof " + functionName + " === 'function');" + "\")");

        return false;
    }

    public execute(commandVars: any = null): void {
        if (ExternalInterface.available) {

            // checks if js function is available, if not try to load js file
            if (!this.checkIfJsFunctionExists(FacebookSettings.FACEBOOK_JS_LOGIN_METHOD)) {
                this.loadJS(FacebookSettings.FACEBOOK_JS_PATH);
            }
        }

    }
}

